import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

import styles from './main.scss';

type BadgeProps = {
    children: React.ReactNode;
    type?: 'neutral' | 'alert';
};

export const Badge: FunctionComponent<BadgeProps> = props => {
    const { children, type } = props;

    const badgeClasses = classnames(styles.badge, {
        [styles.badgeNeutral]: type === 'neutral',
        [styles.badgeAlert]: type === 'alert',
    });

    const badgeInnerClasses = styles.badgeInner;

    return (
        <div className={badgeClasses}>
            <div className={badgeInnerClasses}>{children}</div>
        </div>
    );
};
